import { LeadSource, LEAD_SOURCE_LABEL } from '../../types/lead';

const SOURCE_STYLE: Record<LeadSource, string> = {
  manual: 'bg-gray-100 text-gray-700',
  web_form: 'bg-indigo-100 text-indigo-700',
  import: 'bg-cyan-100 text-cyan-700',
  referral: 'bg-pink-100 text-pink-700',
  email: 'bg-blue-100 text-blue-700',
  phone: 'bg-emerald-100 text-emerald-700',
  event: 'bg-orange-100 text-orange-700',
  other: 'bg-slate-100 text-slate-700',
};

interface Props {
  source: LeadSource;
  detail?: string | null;
  className?: string;
}

export default function LeadSourceBadge({ source, detail, className = '' }: Props) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${SOURCE_STYLE[source]} ${className}`}
      title={detail || undefined}
    >
      {LEAD_SOURCE_LABEL[source]}
      {detail ? <span className="ml-1 opacity-70">· {detail}</span> : null}
    </span>
  );
}
